import React, { useContext } from 'react';
import tw from 'twin.macro';
import { PreferenceContext } from '../context';
import { Button } from '../button';
import { KudosStyle } from './Kudos';

export const KudoActionButton = ({
  direction,
  animation,
  color,
  kudoAction,
  IconType,
  ...restProps
}) => {
  const {
    preference: { theme },
  } = useContext(PreferenceContext);
  const isLightTheme = theme === 'light';
  const upKudoGiven = kudoAction.given && kudoAction.direction === 'up';
  const downKudoGiven = kudoAction.given && kudoAction.direction === 'down';

  return (
    <div tw='relative' {...restProps}>
      <Button
        iconProps={{
          Type: IconType,
          color:
            upKudoGiven && direction === 'up'
              ? 'success'
              : downKudoGiven && direction === 'down'
                ? 'danger'
                : 'icons',
        }}
        secondary={!isLightTheme}
        css={[
          isLightTheme && tw`border-icons bg-primary`,
          !kudoAction.given && tw`transition-transform hover:scale-110 active:scale-95`,
        ]}
        aria-hidden='true'
        disabled={(upKudoGiven && direction === 'up') || (downKudoGiven && direction === 'down')}
      />
      <div
        css={[
          tw`absolute top-1 opacity-0 pointer-events-none -z-10 scale-100`,
          upKudoGiven && direction === 'up' && tw`text-success left-9 scale-150`,
          downKudoGiven && direction === 'down' && tw`text-danger right-9 scale-150`,
          animation && tw`ease-in-out duration-75 transition-all opacity-80`,
          animation && upKudoGiven && direction === 'up' && tw`text-success -translate-y-5`,
          animation && downKudoGiven && direction === 'down' && tw`text-danger translate-y-5`,
        ]}
      >
        <KudosStyle numKudos={downKudoGiven && direction === 'down' ? '-1' : '1'} hideLabel />
      </div>
    </div>
  );
};
